const INITIAL_STATE = {
  filters: {},
  list: {
    initialized: false,
    selectedIndex: null,
    hoverIndex: null,
    items: [],
    others: null,
    orders: {},
    length: 0,
    page: 0,
    rowsPerPage: 50,
  },
};

export default INITIAL_STATE;
